import script from "./Autoscaler.vue?vue&type=script&setup=true&lang=ts"
export * from "./Autoscaler.vue?vue&type=script&setup=true&lang=ts"

import "./Autoscaler.vue?vue&type=style&index=0&id=31ad321a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ad321a"]])

export default __exports__